import PurchasesIndex from '@/history/views/purchases/Index.vue';
import UseIndex from '@/history/views/use/Index.vue';

const routes = [
  {
    path: '/my-account/history/purchases/',
    name: 'History-Purchases',
    component: PurchasesIndex,
  },
  {
    path: '/my-account/history/use/',
    name: 'History-Use',
    component: UseIndex,
  },
];

export default routes;
